import { Component, OnInit } from '@angular/core';
import { AuthService, LoadingPanelService, LocalService } from 'lib-base';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { AuthenticatedLayoutComponent } from '../../layouts/authenticated-layout/authenticated-layout.component';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [
    CommonModule, RouterModule, AvatarModule, AvatarGroupModule, TranslateModule , ButtonModule
  ],
  templateUrl: './app-top-bar.component.html',
  styleUrl: './app-top-bar.component.scss'
})
export class AppTopBarComponent implements OnInit {
  activeItem !: number;
  userName !: string;
  shortName !: string;

  constructor(public appMain: AuthenticatedLayoutComponent, private _ls: LocalService, private _as: AuthService, private _lps: LoadingPanelService) { }

  ngOnInit(): void {
    this.getUserNames();
  }

  get isLoggedIn(): boolean {
    return this._ls.isLoggedIn;
  }

  mobileMegaMenuItemClick(index: any) {
    this.appMain.megaMenuMobileClick = true;
    this.activeItem = this.activeItem === index ? null : index;
  }

  logout(): void {
    this._lps.show(true);
    this._as.logout().subscribe({next: (response) => {
      this._lps.hide();
    }});
  }
  getUserNames(): void {
    this.userName = this._ls.getUser.fullName;
    this.shortName = this.userName ? this.userName[0]?.toUpperCase() : "";
  }

}
